<template>
  <f7-page
    ref="page"
    name="assets"
    infinite
    :infinite-distance="100"
    :infinite-preloader="isLoading"
    @infinite="onLoadMore"
  >
    <f7-progressbar v-if="isLoading" color="green" infinite class="position-absolute" key="1"></f7-progressbar>
    <f7-navbar :sliding="false">
      <!--<f7-nav-left v-if="!customerCode" >
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" href="/panel-left/"></f7-link>
      </f7-nav-left>-->

      <f7-nav-left>
        <f7-link
          icon-ios="f7:menu"
          icon-aurora="f7:menu"
          icon-md="material:menu"
          href="/panel-left/"
        ></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>{{ $t('Assets') }} {{!customerName ? '' : '- ' + customerName }}</f7-nav-title>
      <f7-nav-right>
        <!--<f7-link icon-only href="/notifications/">
          <f7-icon icon="f7-icons icon-notifications">
            <f7-badge v-if="NewNotificationsCount !== 0" color="red">{{ NewNotificationsCount }}</f7-badge>
          </f7-icon>
        </f7-link>-->
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar position="top" class>
      <form class="searchbar custom-searchbar" @submit.prevent="onSearchSubmit">
        <div class="searchbar-inner">
          <div class="searchbar-input-wrap">
            <input type="search" v-model.trim="search" :placeholder="$t('SearchByNameImeiSim')" />
            <span class="input-clear-button"></span>
            <button type="submit" class="submit-button ripple">
              <i class="icon f7-icons icon-search"></i>
            </button>
          </div>
        </div>
      </form>
    </f7-toolbar>

    <f7-block v-if="!isFirstSearchDone">
      <p v-html="$t('SearchDescription')"></p>
    </f7-block>
    <f7-block v-else-if="!isLoading && isNoData && queryPage === 1">
      <p>{{ $t('NoAssetsFound') }}</p>
    </f7-block>

    <f7-list
      ref="vl"
      class="vl vl-assets no-margin-top media-center bigger-item-text"
      virtual-list
      media-list
      no-hairlines
      :virtual-list-params="{ items, renderExternal, height: heightCalc }"
    >
      <ul>
        <f7-list-item
          v-for="(item, index) in vlData.items"
          link="#"
          :key="index"
          :title="item.Name"
          :header="item.Owner"
          :style="`top: ${vlData.topPosition}px`"
          @click="openItemMenu(item, index)"
        >
          <template #media>
            <img
              v-if="item.Photo && /^IMEI_/i.test(item.Photo)"
              slot="media"
              :src="assetImageURL+item.Photo"
              alt
            />
            <f7-icon
              v-else
              :icon="`f7-icons icon-${ getAssetTypeIcon(item.AssetType) } text-color-lightgray`"
            ></f7-icon>
            <span class="status" :class="getAssetStatusClass(item.RAG)"></span>
          </template>
          <template #text>
            <div>
              {{ $t('IMEI') }}:
              <b>{{ item.IMEI ? item.IMEI : $t('na') }}</b>
            </div>
            <div>
              {{ $t('IMSI') }}:
              <b>{{ item.SimNO ? item.SimNO : $t('na') }}</b>
            </div>
            <div>
              {{ $t('SolutionType') }}:
              <b>{{ item.Solution ? item.Solution : $t('na') }}</b>
            </div>
            <div>
              {{ $t('DeviceType') }}:
              <b>{{ item.Product ? item.Product : $t('na') }}</b>
            </div>
          </template>
        </f7-list-item>
      </ul>
    </f7-list>

    <asset-menu v-model:isOpened="isAssetMenuOpened" :assetData="selectedAssetData" />
  </f7-page>
</template>

<script>
import { HideKeyboard, getAssetTypeIcon } from "../../js/helpers";
import { f7, theme } from "framework7-vue";
import { mapGetters } from "vuex";
import { ApiMethods, QTAPI } from "../../services/qt-api";
import $$ from "dom7";

import AssetMenu from "./components/asset-menu";

export default {
  name: "assets",

  props: {
    f7router: Object,
    f7route: Object
  },

  components: {
    AssetMenu
  },
  data() {
    return {
      isLoading: false,
      isFirstSearchDone: false,
      isNoData: false,
      isInfiniteAllowed: true,
      isAssetMenuOpened: false,
      assetImageURL: ApiMethods.ASSET_IMAGE_URL,

      items: [],
      vlData: {
        items: []
      },
      vl: null,
      queryPage: 1,
      search: "",
      selectedAssetData: {},

      customerName: this.f7route.query.customerName,
      customerCode: this.f7route.query.customerCode
    };
  },

  computed: {
    ...mapGetters([
      "MajorToken",
      "MinorToken",
      "UserInfo",
      "AssetUpdateKey",
      "NewNotificationsCount"
    ])
  },

  watch: {
    AssetUpdateKey() {
      this.onSearchSubmit();
    }
  },

  mounted() {
    this.vl = f7.virtualList.get(this.$refs.vl.$el);
    //console.log(this.$refs.vl.$el)
    //if(this.customerCode){
    this.onSearchSubmit();
    //}
  },

  methods: {
    getAssetTypeIcon(assetType) {
      return !assetType ? "assets" : getAssetTypeIcon(assetType);
    },
    getAssetStatusClass(rag) {
      let ragColors = {
        "9_NO_DATA": "status-gray",
        "3_OFFLINE": "status-red",
        "2_OFFLINE": "status-orange",
        "1_ONLINE": "status-green"
      };
      return ragColors[rag] ? ragColors[rag] : "status-gray";
    },
    onSearchSubmit() {
      //hide keyboard at phones
      HideKeyboard();
      //fix to not loadMore when user has scrolled down list
      $$(this.$refs.page.$el)
        .find(".page-content.infinite-scroll-content")
        .scrollTo(0, 0);

      this.queryPage = 1;
      this.isInfiniteAllowed = true;
      this.getData();
    },
    onLoadMore() {
      if (!this.isInfiniteAllowed) return;
      this.isInfiniteAllowed = false;
      ++this.queryPage;
      this.getData();
    },
    async getData() {
      var data = {
        MajorToken: this.MajorToken,
        MinorToken: this.MinorToken,

        page: this.queryPage,
        rows: 20,
        sort: "Name",
        order: "asc",

        q: this.search
      };
      if (this.customerCode) {
        data.CsCode = this.customerCode;
      }
      this.isLoading = true;
      let result = await QTAPI.GetAssetList(data);

      this.isLoading = false;
      this.isFirstSearchDone = true;
      if (!result) {
        return;
      }
      console.log("result", result);
      this.isNoData = !result.rows.length;
      if (this.queryPage === 1) {
        if (this.isNoData) {
          this.vl.deleteAllItems();
          return;
        }
        this.vl.replaceAllItems(result.rows);
      } else {
        if (this.isNoData) {
          return;
        }
        this.vl.appendItems(result.rows);
        this.isInfiniteAllowed = true;
      }
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    },
    heightCalc(item) {
      if (!item.Name) {
        return theme.ios ? 118 : 122;
      }
      return theme.ios ? 141 : 146;
    },

    openItemMenu(item) {
      console.log("item", item);
      this.selectedAssetData = item;
      this.isAssetMenuOpened = true;
    }
  },

  beforeDestroy() {}
};
</script>